import { useCallback, useState, useEffect } from 'react';

/**
 * Generic handler to toggle a boolean state
 * @param {boolean} open - initial state
 * @param {Function} [onToggle= () => {}] - your callback
 * @returns {[boolean, Function]} the function is a useCallback type
 */
export const useToggleHandler = (open, onToggle = () => {}) => {
  const [isOpen, setOpen] = useState(open);
  useEffect(() => {
    if (open !== isOpen) {
      setOpen(open);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const handleToogle = useCallback(() => {
    setOpen(!isOpen);
    onToggle(!isOpen);
  }, [isOpen, onToggle]);

  return [isOpen, handleToogle];
};
